import React from 'react'
import ItemsSection from '../components/sections/itemsSection/ItemsSection'

const Items = () => {
  return (
   <ItemsSection />
  )
}

export default Items